import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-select',
  templateUrl: './service-select.component.html',
  styleUrls: ['./service-select.component.scss']
})
export class ServiceSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
